import { render } from "./CourseBigData.vue?vue&type=template&id=611f7540&scoped=true"
import script from "./CourseBigData.vue?vue&type=script&lang=js"
export * from "./CourseBigData.vue?vue&type=script&lang=js"

import "./CourseBigData.vue?vue&type=style&index=0&id=611f7540&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-611f7540"]])

export default __exports__